import '../scss/style.scss';

import './_tab-switcher.js';
import './_youtube-rss.js';
